"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var convertTimePeriodToDate_1 = __importDefault(require("./convertTimePeriodToDate"));
var format_1 = __importDefault(require("./format"));
var PROP_KEYS = ['dateFrom', 'dateTo'];
function formatDateBeforeRequest(variables) {
    return PROP_KEYS.reduce(function (inputVars, key) {
        var vars = inputVars;
        var date = convertTimePeriodToDate_1.default(variables[key]);
        vars[key] = date
            ? // Output format 2020-09-30T00:00:00+03:00
                format_1.default(date, "yyyy-MM-dd'T'HH:mm:ssxxx")
            : undefined;
        return vars;
    }, __assign({}, variables));
}
exports.default = formatDateBeforeRequest;
//# sourceMappingURL=formatDateBeforeRequest.js.map